import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {Translate} from '../../i18n/i18n';
import ResourceImage from '../../ResourceImage/ResourceImage';
import { Container, ImageRow, ImageThumb, ImageName, ImageFilter, ImageList, ImageGroup, ImageButton } from './ImagesList.styles';
import { filemanagerActions } from '../../../redux/actions';

export default ({value, onChange, tableId}) => {

    const dispatch = useDispatch();
    const allFiles = useSelector(state => state.filemanagerState.files);
    const [files, setFiles] = useState([]);
    const [filter, setFilter] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        setSelectedFile(value);
    }, [value]);

    useEffect(() => {
        (async () => {
            if (allFiles && allFiles.length) {
                setFiles(allFiles.filter(i => String(i.mimetype).includes('image')))
            }
        })();
    }, [allFiles, tableId]);

    useEffect(() => {
        if (allFiles && allFiles.length) {
            setFiles(allFiles.filter(i => String(i.mimetype).includes('image') && String(i.name).includes(filter)))
        }
    }, [filter, allFiles]);

    const handleManageFiles = () => {
        dispatch(filemanagerActions.openWindow('single', async (result) => {
            setSelectedFile(result[0]);
        }))
    }

    const handleSelectFile = (file) => {
        setSelectedFile(file);
        if (onChange) {
            onChange(file);
        }
    }

    return <Container className={"scrollbar"}>
        <ImageGroup>
            <ImageFilter placeholder={Translate('gridtools.filterimage')} value={filter} onChange={(e)=>{setFilter(e.target.value)}} />
            <ImageButton onClick={handleManageFiles} width={"30px"} color={"#39f"} icon={"\\F0216"} title={Translate('gridtools.managefiles')} />
        </ImageGroup>
        <ImageList>
            {files && files.length ? files.map((file,i) => <ImageRow key={i} className={selectedFile === file.id ? 'selected' : ''} onClick={() => {handleSelectFile(file.id)}}>
                <ImageThumb>
                    <ResourceImage resourceId={file.id} isThumbnail={true} />
                </ImageThumb>
                <ImageName>{file.name}</ImageName>
            </ImageRow>) : null}
        </ImageList>
    </Container>
}